var map = {
	"./AddProductModal": 2816,
	"./AddProductModal.jsx": 2816,
	"./App": 1300,
	"./App.css": 3907,
	"./App.jsx": 1300,
	"./CartPopup": 3676,
	"./CartPopup.jsx": 3676,
	"./Home": 8372,
	"./Home.jsx": 8372,
	"./Logo": 3985,
	"./Logo.jsx": 3985,
	"./MamopayCheckout": 6716,
	"./MamopayCheckout.jsx": 6716,
	"./Map": 9888,
	"./Map.jsx": 9888,
	"./Menu": 7808,
	"./Menu.jsx": 7808,
	"./MenuCartPopup": 2712,
	"./MenuCartPopup.jsx": 2712,
	"./MenuShow": 4928,
	"./MenuShow.jsx": 4928,
	"./ModalError": 9792,
	"./ModalError.jsx": 9792,
	"./ModalNotificationPrompt": 8432,
	"./ModalNotificationPrompt.jsx": 8432,
	"./ModalPaymentFailed": 1841,
	"./ModalPaymentFailed.jsx": 1841,
	"./ModalPaymentSuccess": 2752,
	"./ModalPaymentSuccess.jsx": 2752,
	"./Navigation": 3968,
	"./Navigation.jsx": 3968,
	"./OrderPreview": 6288,
	"./OrderPreview.jsx": 6288,
	"./OrderSearch": 4992,
	"./OrderSearch.jsx": 4992,
	"./OrderStatus": 316,
	"./OrderStatus.jsx": 316,
	"./ProductDetailPopup": 8216,
	"./ProductDetailPopup.jsx": 8216,
	"./admin/AdminHome": 8608,
	"./admin/AdminHome.jsx": 8608,
	"./admin/AdminSignIn": 2048,
	"./admin/AdminSignIn.jsx": 2048,
	"./admin/CustomFoodAvailability": 7304,
	"./admin/CustomFoodAvailability.jsx": 7304,
	"./admin/OrderDetail": 3656,
	"./admin/OrderDetail.jsx": 3656,
	"./admin/OrderList": 100,
	"./admin/OrderList.jsx": 100,
	"./admin/UpdateMenuStatus": 7964,
	"./admin/UpdateMenuStatus.jsx": 7964,
	"./admin/UpdateShowMenu": 1408,
	"./admin/UpdateShowMenu.jsx": 1408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8164;